export default "__VITE_ASSET__CZWKH0uN__"